import { useInactivityLogout } from '../hooks/useInactivityLogout';

/** Active le timeout d'inactivité pour toute session connectée. */
export default function InactivityLogoutWatcher() {
  useInactivityLogout();
  return null;
}
